module.exports = __webpack_public_path__ + "img/p7-p1-yanzi.a5ee53c1.png";